import { useContext, JSX } from 'react';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import { Handle, Position, useReactFlow, ReactFlowInstance, Node } from "@xyflow/react";
import SettingsIcon from '@mui/icons-material/Settings';
import CheckIcon from "@mui/icons-material/Check";

function WorkflowDataMoveNode({id, data}: { id: any, data: any }): JSX.Element {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance: ReactFlowInstance = useReactFlow();

    function handleShowErrorConfigurationClick() {
        let node: Node = reactFlowInstance.getNode(id);
        context.setActiveEditMoveNode(node);
    }

    function successfulTest(): string {
        let returnValue: string = '';
        if (!!context.testComplete.includes(id)) {
            returnValue = ' test-success'
        }

        if (!!context.testProcessing.includes(id)) {
            returnValue = ' test-processing'
        }

        if (!!context.testErrored.includes(id)) {
            returnValue = ' test-error';
        }

        return returnValue;
    }

    return (
        <div className={ "workflow-node moving " + id + " "  + (successfulTest()) }>
            { (successfulTest() !== '') &&
                <div className={ successfulTest() + "-icon" } />
            }
            <Handle type="target" id="moving-node-target" position={ Position.Top } >
                <span className="handle-label top" >{ "Input" }</span>
            </Handle>
            <div className="node__layout">
                <div className="layout__top">
                    <span className={ "move-icon" }></span>
                </div>
                <div className="layout__middle">
                    <span className={ "label-span" }>
                        { (typeof data?.label === 'string' && data.label.length > 0) ? data.label : 'Move Data Node' }
                    </span>
                </div>
                <div className="layout__bottom">
                    <span className="action-span nodrag" onClick={ handleShowErrorConfigurationClick }>
                        <SettingsIcon />
                    </span>
                </div>
            </div>
            <Handle type="source" id="moving-node-source" position={ Position.Bottom } >
                <span className="handle-label bottom" >{ "Continue" }</span>
            </Handle>
        </div>
    );
}

export default WorkflowDataMoveNode;